// actions/familyAppointmentActions.js
import {
    FAMILY_CREATE_APPOINTMENT_REQUEST,
    FAMILY_CREATE_APPOINTMENT_SUCCESS,
    FAMILY_RESET_APPOINTMENT_STATE,
  } from './familyAppointmentTypes';
  
  // Action to initiate family appointment creation
  export const createFamilyAppointmentRequest = (familyAppointmentData) => ({
    type: FAMILY_CREATE_APPOINTMENT_REQUEST,
    payload: familyAppointmentData,
  });
  
  // Action for successful family appointment storage
  export const createFamilyAppointmentSuccess = (familyAppointment) => ({
    type: FAMILY_CREATE_APPOINTMENT_SUCCESS,
    payload: familyAppointment,
  });
  
  // Action to reset family appointment state
  export const resetFamilyAppointmentState = () => ({
    type: FAMILY_RESET_APPOINTMENT_STATE,
  });
  
  // Action creator to handle family appointment storage (synchronous)
  export const createFamilyAppointment = (familyAppointmentData) => (dispatch) => {
    dispatch(createFamilyAppointmentRequest(familyAppointmentData));
    dispatch(createFamilyAppointmentSuccess(familyAppointmentData));
  };